import * as Sentry from "@sentry/react";
import { setToken } from "../../modules/feedManager/store";
import { DATA_PRODUCER_WORKSHEET_NAME, DATA_SOURCE_WORKSHEET_NAME } from "../../service/globalValues";
import { lockEditModeInSomeColumns } from "../../service/producerServices";
import { getAPIKey } from "../../service/sourceServices";
import { TabId } from "./App";

const createRequiredWorkSheets = async () => {
  try {
    await Excel.run(async (context) => {
      const sheets = context.workbook.worksheets;
      let producerSheet = sheets.getItemOrNullObject(DATA_PRODUCER_WORKSHEET_NAME);
      await context.sync();

      if (producerSheet.isNullObject) {
        producerSheet = sheets.add(DATA_PRODUCER_WORKSHEET_NAME);
        producerSheet.activate();
      }

      let sourceSheet = sheets.getItemOrNullObject(DATA_SOURCE_WORKSHEET_NAME);
      await context.sync();

      if (sourceSheet.isNullObject) {
        sourceSheet = sheets.add(DATA_SOURCE_WORKSHEET_NAME);
        sourceSheet.activate();
      }

      await context.sync();
    });
  } catch (error) {
    Sentry.captureException(
      new Error('Error while creating required worksheets', { cause: error })
    );
  }
};

export const initializeOffice = () => {
  Office.initialize = () => {
    Excel.run(async (context) => {
      await createRequiredWorkSheets();
      await context.sync();

      let sheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);
      sheet.activate();

      lockEditModeInSomeColumns();

      await context.sync();
    });
  };
};

export const getTokenFromWorksheet = async (context: Excel.RequestContext) => {
  try {
    const apiKeyFromWorksheet = await getAPIKey(context);

    return apiKeyFromWorksheet;
  } catch (error) {
    return null;
  }
};

export const getApiKeyFromWorksheet = async (
  dispatch: any,
  setSelectedTab: (value: React.SetStateAction<TabId>) => void
) => {
  Excel.run(async (context) => {
    const apiKeyFromWorksheet = await getTokenFromWorksheet(context);

    if (!apiKeyFromWorksheet) return;

    dispatch(setToken(apiKeyFromWorksheet));
    setSelectedTab(TabId.FeedManager);

    await context.sync();
  });
};
